import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, Send, CheckCircle2, Loader2, ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { forgot } = useAuth();
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    try {
      await forgot(email);
      setState("sent");
    } catch {
      setState("sent"); // do not reveal account existence
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#16244F] to-[#2b3f7a] px-5 py-10">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 md:p-10">
        <div className="flex justify-center mb-6"><Logo height={48} /></div>
        {state === "sent" ? (
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#16a34a]/10 text-[#16a34a] mb-4"><CheckCircle2 size={32} /></div>
            <h1 className="font-head text-2xl font-bold text-[#16244F]">Check your inbox</h1>
            <p className="text-[#5a6274] mt-2">If an account exists for <strong>{email}</strong>, we've sent a password reset link. It expires in 1 hour.</p>
            <button onClick={() => navigate("/login")} className="mt-6 inline-flex items-center gap-1.5 text-[#F58220] font-head font-semibold"><ArrowLeft size={16} /> Back to login</button>
          </div>
        ) : (
          <>
            <h1 className="font-head text-2xl font-bold text-[#16244F] text-center">Forgot password?</h1>
            <p className="text-center text-[#8a90a0] text-sm mt-1 mb-6">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="relative">
                <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8a90a0]" />
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-200 focus:border-[#2b8cf0] focus:ring-2 focus:ring-[#2b8cf0]/20 outline-none transition" />
              </div>
              <button type="submit" disabled={state === "sending"} className="w-full inline-flex items-center justify-center gap-2 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold py-3.5 rounded-lg transition-colors disabled:opacity-70">
                {state === "sending" ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />} Send Reset Link
              </button>
            </form>
            <button onClick={() => navigate("/login")} className="block mx-auto mt-5 text-sm text-[#8a90a0] hover:text-[#16244F]">← Back to login</button>
          </>
        )}
      </div>
    </div>
  );
}
